const isJobCancelDisabled = (status: string) => {
  switch (status) {
    case 'Confirmed':
    case 'Allocated':
    case 'OnRoute':
    case 'Arrived':
    case 'Driver_Allocated':
    case 'Manual_Intervention_Required':
      return false
    default:
      return true
  }
}

export default isJobCancelDisabled
